module.exports = __webpack_public_path__ + "static/media/err-bg.69836a7b.svg";